import type { ButtonHTMLAttributes, ReactNode } from 'react';
import { Button as UiButton } from './ui/button';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  loading?: boolean;
  variant?: 'primary' | 'secondary' | 'danger';
  children: ReactNode;
}

// Legacy app Button — now a thin adapter over the shadcn ui/button, so every
// existing consumer (auth, settings, model rows, prompts) inherits the Studio
// styling, focus rings and consistent sizing in one move. Preserves the old API
// (primary/secondary/danger + loading) and the "Please wait…" text the suites
// assert. New code should import { Button } from './ui/button' directly.
const VARIANT_MAP = {
  primary: 'default',
  secondary: 'secondary',
  danger: 'destructive',
} as const;

export default function Button({
  loading,
  variant = 'primary',
  disabled,
  children,
  ...rest
}: ButtonProps) {
  return (
    <UiButton variant={VARIANT_MAP[variant]} disabled={disabled || loading} {...rest}>
      {loading ? 'Please wait…' : children}
    </UiButton>
  );
}
